const LOCAL_STORAGE_PREFIX = "call_parking_wallboard_"

export const localStorageHelper = {
    getItem(key) {
        return localStorage.getItem(LOCAL_STORAGE_PREFIX + key)
    },
    setItem(key, value) {
        localStorage.setItem(LOCAL_STORAGE_PREFIX + key, value)
    },
    removeItem(key) {
        return localStorage.removeItem(LOCAL_STORAGE_PREFIX + key)
    },
    clear() {
        Object.keys(localStorage).filter(v => v.startsWith(LOCAL_STORAGE_PREFIX)).forEach(key => localStorage.removeItem(key));
    }
}